import { useMutation } from "react-query";
import { deleteAreaOfConcern } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

export const useDeleteAreaOfConcern = (options: Record<string, any> = {}) => {
  const { onSuccess = () => {}, onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ clientId, id }: { clientId: number; id: number }) => deleteAreaOfConcern(clientId, id),
    {
      onSuccess: (response, variables) => {
        showToast({ message: "Area of concern deleted successfully." });
        onSuccess(response, variables);
      },
      onError: (error: any, variables, context) => {
        const message =
          error?.response?.status === 403
            ? "You don't have permission to delete areas of concern."
            : "Whoops! Something went wrong while deleting the area of concern.";
        showToast({ message, errorState: true });
        onError(error, variables, context);
      },
      ...otherOptions,
    }
  );

  return {
    deleteAreaOfConcernMutation: mutate,
    isDeleteAreaOfConcernLoading: isLoading,
    ...rest,
  };
};

export default useDeleteAreaOfConcern;
